import { type MouseEvent, type RefObject, useEffect } from 'react'

const isDialogNotSupported = window.HTMLDialogElement === undefined

const useDialogPolyfill = (ref: RefObject<HTMLDialogElement>) =>
	useEffect(() => {
		if (isDialogNotSupported && ref.current) {
			const dialog = ref.current
			import('dialog-polyfill').then(({ default: polyfill }) =>
				polyfill.registerDialog(dialog)
			)
		}
	}, [ref])

function closeOnBackdropClick(event: MouseEvent<HTMLDialogElement>) {
	const dialog = event.currentTarget
	if (event.target === dialog) {
		dialog.close()
	}
}

export { closeOnBackdropClick, useDialogPolyfill }
